// extracted by mini-css-extract-plugin
export default {"attachedImage":"attachedImage_attachedImage__ECSoj"};